export default "__VITE_ASSET__dY73lcCT__"